export default __webpack_public_path__ + "6b92ca1c0857979e4d508e86313e5460.png";